module.exports = "<div class=\"map-container\" #mapContainer (click)=\"handleClick()\"></div>"